import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen px-6 py-12 bg-richblack-900 text-richblack-25 max-w-4xl mx-auto">
      <h1 className="text-3xl font-semibold text-yellow-100 mb-6">
        Terms and Conditions
      </h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Terms of Service
        </h2>
        <p className="text-richblack-200 mb-4">
          Welcome to “CNT ACADEMY” Terms of Use agreement. For purposes of this
          agreement, CNTACADEMY is owned and operated by Agnostic Edufin Pvt Ltd
          (hereinafter referred to as “Company”, a company incorporated under
          the Companies Act, having its registered office at 212, Girish Ghosh
          Road, Room No-430, 4th Floor, P.S. Belur, Howrah, Pin - 711202 State:
          West Bengal, India.
        </p>
        <p className="text-richblack-200 mb-4">
          “Site” refers to the Company’s website, which can be accessed at{" "}
          <a
            href="https://www.cntacademy.com"
            className="text-yellow-100 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.cntacademy.com
          </a>{" "}
          or through our mobile application (“App”) – CNT ACADEMY or CNT
          (abbreviated). You are advised to read and understand these Terms
          carefully as moving past the home page, or using any of the services
          shall be taken to mean that You have read and agreed to all of the
          policies, which constitute a legally binding agreement between you and
          the website. These terms are to be read along with the Privacy Policy
          and any other policies on the website.
        </p>
        <p className="text-richblack-200 mb-4">
          This document is an electronic record published in accordance with the
          provisions of the Information Technology (Intermediaries guidelines)
          Rules, 2011 that require publishing the Rules and Regulations, Privacy
          Policy and Terms of Service for access or usage of the website and
          being generated by a computer system, it does not require any physical
          or digital signatures.
        </p>
        <p className="text-richblack-200 mb-4">
          For the purpose of these Terms of Use, along with any amendments to
          the same, and wherever the context so requires “You”, “Your” or “User”
          refer to the person visiting, accessing, browsing through and/or using
          the Website at any point in time. The term “We”, “Us”, “Our” shall
          mean and refer to the website and/or the Company, depending on the
          context.
        </p>
        <p className="text-richblack-200 mb-4">
          The headings of each section in this Agreement are only for the
          purpose of organising the various provisions under this Agreement in
          an orderly manner. These headings shall not be used by either party to
          interpret the provisions contained under them in any manner. Further,
          the headings have no legal or contractual value.
        </p>
        <p className="text-richblack-200 mb-4">
          We hold the sole right to modify the Terms of Service without prior
          permission from You or providing notice to You. The relationship
          creates on You a duty to periodically check the Terms of Service and
          stay updated on its requirements. If You continue to use the Website
          or avail any of its services without registration following such
          change, this is deemed as consent by You to the so amended policies.
          Your continued use of the Website is conditioned upon your compliance
          with the Terms of Service, including but not limited to compliance
          with the Terms of Service even after alterations, if any.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Services Overview
        </h2>
        <p className="text-richblack-200 mb-4">
          The Website & Mobile APP is an online platform which provides users
          with courses and learning material with relation to finance & Stock
          Market. The User shall have the option of choosing the study material
          and the courses that they wish to have access to and purchase the
          same.
        </p>
        <p className="text-richblack-200 mb-4">
          CNT Academy is a young vibrant company established with the vision of
          taking online financial education to the reach of every class of
          investor and trader both in India and abroad. At CNT Academy, our
          mission is to empower individuals with financial literacy by
          leveraging innovative educational methodologies and technologies. We
          are committed to making financial education accessible, effective, and
          convenient for all.
        </p>
        <p className="text-richblack-200 mb-4">Whether you are:</p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2">
          <li>
            ✔️ A student seeking in-depth knowledge of financial markets or
            career opportunities
          </li>
          <li>
            ✔️ A working professional aiming for career advancement or better
            job prospects
          </li>
        </ul>
        <p className="text-richblack-200 mt-2">
          CNT Academy is your ultimate learning destination.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Registration
        </h2>
        <p className="text-richblack-200 mb-4">
          To use the services provided on the website and make purchases, it is
          compulsory to create an account.
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            To access certain services, you may be required to create a user
            account.
          </li>
          <li>
            You are responsible for maintaining the confidentiality of your
            account information.
          </li>
          <li>
            You agree to provide accurate and up-to-date information during the
            account creation process.
          </li>
          <li>Website shall collect only Your basic information.</li>
        </ul>
        <p className="text-richblack-200 mb-4">
          You also have the option of linking your social media accounts, such
          as Google Plus account with the CNT Academy account, to create your
          account.
        </p>
        <p className="text-richblack-200 mb-4">
          At the time of registration, CNT Academy collects personal information
          such as name, email, phone number, demographic details, and
          educational requirements. If you link your social media account, basic
          details like name, age, gender, location, and email may also be
          collected. This data is governed by the company’s Privacy Policy.
        </p>
        <p className="text-richblack-200 mb-4">
          You are responsible for maintaining the confidentiality of your
          username and password, and any activity on your account will be
          considered as done by you. Providing false or inaccurate information
          may result in permanent suspension of your account.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Access to your personal information
        </h2>
        <p className="text-richblack-200 mb-4">
          Registered users can view the categories of personal information
          collected about them in the Profile section of their account. However,
          certain sensitive details, such as account passwords, may be withheld
          if disclosure poses a risk to the user or the business.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Right to request deletion of your personal information
        </h2>
        <p className="text-richblack-200 mb-4">
          Users can request the deletion of their personal information through
          the self-service option in their profile or via the "Delete My
          Account" link. However, some data may be retained as required by law
          for service provision, fraud prevention, legal compliance, or internal
          business purposes.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Eligibility
        </h2>
        <p className="text-richblack-200 mb-4">
          CNT Academy's services are available via digital means and are not
          accessible to individuals incompetent to contract under the Indian
          Contract Act, 1872, including minors and insolvents.
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            🔹 Minors (ages 13-18) can use the site only under parental or legal
            guardian supervision who agrees to the Terms of Use.
          </li>
          <li>
            🔹 CNT Academy may terminate or deny access if a user is found to be
            a minor without proper supervision.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Security
        </h2>
        <p className="text-richblack-200 mb-4">
          All transactions on the website are secure and encrypted to protect
          user data. CNT Academy does not store or retain credit/debit card
          details. Payment information is directly processed by an authorized
          payment gateway that complies with banking and regulatory
          requirements.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          License And Access
        </h2>
        <p className="text-richblack-200 mb-4">
          CNT Academy grants users a limited sub-license to access and use the
          site for personal purposes only. Users cannot download, modify,
          resell, or commercially exploit any content without explicit written
          consent. Unauthorized activities such as data mining, copying, framing
          trademarks, or hacking are strictly prohibited.
        </p>
        <p className="text-richblack-200 mb-2">
          Users must not upload or share content that:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>❌ Belongs to someone else without permission</li>
          <li>❌ Is harmful, defamatory, obscene, or unlawful</li>
          <li>
            ❌ Encourages illegal activities like gambling or money laundering
          </li>
          <li>❌ Infringes intellectual property rights</li>
          <li>❌ Contains misleading, offensive, or false information</li>
          <li>❌ Spreads viruses or threatens national security</li>
        </ul>
        <p className="text-richblack-200">
          Violation of these terms may result in account suspension or legal
          action. 🚨
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Communications
        </h2>
        <p className="text-richblack-200 mb-4">
          By using this website, you consent to receiving calls, emails,
          WhatsApp, Telegram messages, and SMS from CNT Academy for
          clarifications, marketing, and promotions, as per the Privacy Policy.
        </p>
        <p className="text-richblack-200 mb-2">📢 Key Points:</p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            ✅ You agree to receive promotional communications and newsletters.
          </li>
          <li>
            ✅ Contact may come from CNT Academy, its partners, or authorized
            service providers.
          </li>
          <li>
            ✅ You can opt out anytime by unsubscribing on the website or
            emailing info@cntacademy.com.
          </li>
          <li>
            ✅ Your contact details will not be shared with unauthorized third
            parties.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Membership & Payment Summary
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            ✔️ Membership is free for browsing and basic services, but courses
            and materials are paid.
          </li>
          <li>
            ✔️ The company may revise charges, and users will be notified.
            Changes take effect upon posting.
          </li>
        </ul>
        <p className="text-richblack-200 mb-2">
          Payment Options: All payments are done via authorised Payment gateway.
        </p>
        <p className="text-richblack-200 mb-2">💳 Accepted Methods:</p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>• Visa, MasterCard, and Amex credit & debit cards</li>
          <li>• Net banking from selected Indian banks</li>
          <li>
            • Payments will be reflected on bank/credit card statements under
            the company’s name (format may vary).
          </li>
          <li>
            • Successful payment completion is required to access paid services.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Fraudulent Activity
        </h2>
        <p className="text-richblack-200 mb-4">
          Beware of Fraudulent Representatives!
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            ⚠️ Do NOT engage with individuals or entities claiming to represent
            CNT Academy without verification.
          </li>
          <li>
            ⚠️ Such actors are not authorized, and dealing with them risks
            fraud.
          </li>
          <li>
            ⚠️ CNT Academy is not responsible for any losses, payments, or
            transactions made with these unauthorized parties.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          User Restrictions & Responsibilities on the Website
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            🔹 Limited Use: Users cannot copy, modify, distribute,
            reverse-engineer, or sell any website content without permission.
          </li>
          <li>
            🔹 Unauthorized Access: Automated tools, hacking, or data mining to
            access the site or its content are prohibited.
          </li>
          <li>
            🔹 Content Restrictions: Users must not post offensive, harmful,
            illegal, or misleading content.
          </li>
          <li>
            🔹 Prohibited Activities: Users must not impersonate others, disrupt
            website operations, infringe intellectual property, or violate laws.
          </li>
          <li>
            🔹 No Unauthorized Advertising: Spamming, solicitation, and chain
            messages are forbidden.
          </li>
          <li>
            🔹 Legal Compliance: The platform may disclose user data to
            authorities if required by law.
          </li>
          <li>
            🔹 Monitoring & Removal: The website reserves the right to monitor,
            remove, or edit content violating its policies.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Intellectual Property & Third-Party Links
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            🔹 Ownership & Restrictions: All content, trademarks, and
            intellectual property on the website belong to the company or its
            licensors. Users cannot copy, modify, distribute, or store any
            content without permission.
          </li>
          <li>
            🔹 No License Granted: Accessing the site does not grant any rights
            to use the company’s or third-party trademarks, names, or materials.
          </li>
          <li>
            🔹 Third-Party Links: References or links to external sites do not
            imply endorsement by the company. Users accessing third-party sites
            do so at their own risk.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Disclaimer & Limitation of Liability
        </h2>
        <p className="text-richblack-200 mb-4">
          You expressly understand and agree that, to the maximum extent
          permitted by applicable law:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            🔹 No Warranties: The website, services, and content are provided
            "as is" without any guarantees on accuracy, reliability, or
            uninterrupted service.
          </li>
          <li>
            • Users download or use materials at their own risk, and the company
            is not liable for system damage or data loss.
          </li>
          <li>
            • The company is not responsible for errors, omissions, or
            third-party content, tools, or services.
          </li>
          <li>
            • Materials, information and results obtained will be effective,
            accurate or reliable;
          </li>
          <li>
            • Any errors or defects in the website, services or other materials
            will be corrected.
          </li>
        </ul>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>🔹 Educational Purpose Only:</li>
          <li>
            • The company only provides financial education and does not offer
            financial advisory, broking, or PMS services.
          </li>
          <li>
            • If users invest based on the content, they do so at their own
            risk.
          </li>
        </ul>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            🔹 Third-Party Disclaimer: The company does not endorse or take
            responsibility for third-party products, software, or
            advertisements.
          </li>
          <li>
            🔹 Investment Risks: Investments are subject to market risks, and
            users should consult SEBI-registered intermediaries before
            investing.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Indemnification & Limitation of Liability
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            🔹 User Responsibility: You agree to indemnify and protect the
            company, its affiliates, and employees from any claims, losses, or
            damages arising due to:
          </li>
          <li>• Your breach of terms.</li>
          <li>
            • Any third-party claims related to your use of the website or
            posted materials.
          </li>
        </ul>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            🔹 Limited Liability: The company and its team are not liable for:
          </li>
          <li>
            • Indirect, incidental, or consequential damages (loss of data,
            profits, etc.).
          </li>
          <li>
            • Claims arising from contract breaches, negligence, or torts.
          </li>
        </ul>
        <p className="text-richblack-200 mb-4">
          🔹 Maximum Legal Protection: These limitations apply to the fullest
          extent permitted by law.
        </p>
        <p className="text-richblack-200 mb-4">
          You agree to indemnify, defend and hold harmless this website/company
          including but not limited to its affiliate vendors, agents and
          employees from and against any and all losses, liabilities, claims,
          damages, demands, costs and expenses (including legal fees and
          disbursements in connection therewith and interest chargeable thereon)
          asserted against or incurred by us that arise out of, result from, or
          may be payable by virtue of, any breach or non-performance of any
          representation, warranty, covenant or agreement made or obligation to
          be performed by you pursuant to these terms of service. Further, you
          agree to hold us harmless against any claims made by any third party
          due to, or arising out of, or in connection with, your use of the
          website, any claim that your material caused damage to a third party,
          your violation of the terms of service, or your violation of any
          rights of another, including any intellectual property rights.
        </p>
        <p className="text-richblack-200 mb-4">
          In no event shall CNT Academy, its officers, directors, employees,
          partners or suppliers be liable to you, the vendor or any third party
          for any special, incidental, indirect, consequential or punitive
          damages whatsoever, including those resulting from loss of use, data
          or profits, whether or not foreseeable or whether or not we have been
          advised of the possibility of such damages, or based on any theory of
          liability, including breach of contract or warranty, negligence or
          other tortious action, or any other claim arising out of or in
          connection with your use of or access to the website, services or
          materials.
        </p>
        <p className="text-richblack-200">
          The limitations and exclusions in this section apply to the maximum
          extent permitted by applicable law.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Termination of User Agreement
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2">
          <li>
            🔹 User Termination: You can terminate the agreement anytime by
            stopping website use.
          </li>
          <li>
            🔹 Company Termination: The company can terminate your access at any
            time without notice, with no liability.
          </li>
          <li>🔹 Post-Termination Rights & Obligations:</li>
          <li>
            • The company's rights to user comments and indemnification remain
            valid.
          </li>
          <li>
            • Termination does not cancel pending payments or prior liabilities.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Hosting Of Third Party Information
        </h2>
        <p className="text-richblack-200">
          The website displays third-party information, but we are not
          responsible for its accuracy or legitimacy. While we take reasonable
          care, we do not guarantee its correctness. You agree not to hold us
          liable for any false information provided.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Disputes And Jurisdiction
        </h2>
        <p className="text-richblack-200">
          Disputes will be resolved through a two-step Alternate Dispute
          Resolution (ADR) process:
        </p>
        <ol className="list-decimal list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            Mediation – A neutral third-party mediator, agreed upon by both
            sides, will attempt to resolve the dispute. The mediator’s decision
            is not binding.
          </li>
          <li>
            Arbitration – If mediation fails, arbitration follows with a
            three-member board (one appointed by each party and a third chosen
            by them). The arbitration will be held in Kolkata, India, conducted
            in English, and the decision will be final and binding.
          </li>
        </ol>
        <p className="text-richblack-200">
          If unresolved, disputes will be referred to courts in Kolkata, India.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Refund Policy
        </h2>
        <p className="text-richblack-200">
          CNT Academy courses are non-refundable, but refunds may be granted
          under special circumstances if requested within 7 working days of
          purchase. These include:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>Course access not provided.</li>
          <li>
            Duplicate payment made (refund via the original payment method).
          </li>
          <li>Video quality issues making the course non-functional.</li>
          <li>Cancellation of events.</li>
        </ul>
        <p className="text-richblack-200">
          CNT Academy may deny refund requests in the following cases:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            A significant portion of the course has been consumed or downloaded
            before the refund request.
          </li>
          <li>Multiple refund requests for the same course.</li>
          <li>
            The course was purchased through a third-party vendor (refund must
            be requested from them).
          </li>
          <li>
            The course is affiliated with a certification partner or institution
            (refund subject to their approval).
          </li>
          <li>Suspicion of bad faith or service abuse.</li>
          <li>
            The user missed a live course or webinar after access was provided.
          </li>
        </ul>
        <h3 className="text-richblack-5 font-semibold mb-1">
          Refund processing Period
        </h3>
        <p className="text-richblack-200">
          Any refund claim will usually be processed after a period of around 10
          working days after the refund request has been approved by CNT
          Academy.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Privacy
        </h2>
        <p className="text-richblack-200">
          CNT Academy encourages users to read the Privacy Policy to make
          informed decisions about their personal data. Users acknowledge that
          any personal information they voluntarily provide (e.g., photos,
          demographic details) may reveal sensitive details. The company may
          access, store, and disclose such information as needed during website
          usage, with further details on third-party disclosures outlined in the
          Privacy Policy.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Miscellaneous Provisions Summary
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2">
          <li>
            Entire Agreement: This section, along with any expressly agreed
            additional terms, constitutes the full agreement between the Client
            and Service Vendor, overriding any prior discussions or agreements.
          </li>
          <li>
            Waiver: Failure to enforce any provision does not waive the right to
            enforce it later. A waiver of one breach does not apply to other
            breaches.
          </li>
          <li>
            Severability: If any provision is found invalid or unenforceable,
            the remaining terms remain effective, with minimal necessary
            adjustments to uphold the agreement’s intent.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Contact Us
        </h2>
        <p className="text-richblack-200">
          For inquiries regarding these Terms and Conditions, please contact us
          at{" "}
          <a href="mailto:info@cntacademy.com" className="text-yellow-100">
            info@cntacademy.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
